module.exports = "../dist/frontend/icons/symbols/letters/a-green.svg?f9120988b6f38d1d55f9c563dc6cbc03";